import { Modal_Header_default } from "./chunk-T2CSRVJV.js";
import { DialogComponent } from "./chunk-3YPFY763.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Modal/Modal.tsx
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var MODAL_CLASSNAME_MAP = {
  size: {
    sm: "pd:max-w-[25rem]",
    md: "pd:max-w-[38.75rem]",
    lg: "pd:max-w-[52.5rem]",
    xl: "pd:max-w-[64.25rem]"
  }
};
var Modal = _a => {
  var _b = _a,
    {
      isOpen,
      size = "md",
      onClose,
      children,
      title,
      dismissLabel,
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "size", "onClose", "children", "title", "dismissLabel", "className"]);
  return /* @__PURE__ */jsxs(DialogComponent, __spreadProps(__spreadValues({
    isOpen,
    onClose,
    className: clsx("pd:modal", MODAL_CLASSNAME_MAP.size[size], className)
  }, rest), {
    children: [/* @__PURE__ */jsx(DialogComponent.Backdrop, {}), /* @__PURE__ */jsx(DialogComponent.Front, {
      className: "pd:flex pd:items-center pd:justify-center pd:p-3",
      children: /* @__PURE__ */jsxs(DialogComponent.Panel, {
        className: clsx("pd:max-h-full pd:w-full pd:rounded-md pd:align-middle", MODAL_CLASSNAME_MAP.size[size]),
        children: [title && /* @__PURE__ */jsx(Modal_Header_default, {
          title,
          dismissLabel
        }), children]
      })
    })]
  }));
};
var Modal_default = Modal;
export { Modal_default };